import { RootState } from "core-integration/src/store";
import { getElement } from "core-integration/src/store/elements/reducers";
import { getTeamsById } from "core-integration/src/store/teams/reducers";
import {
  bottomRightIcon,
  pitchElementData,
  topLeftIconList,
  topRightIcon,
} from "plos/src/components/ElementCard/ElementCard.css";
import ElementCardButton from "plos/src/components/ElementCard/ElementCardButton";
import ElementName from "plos/src/components/ElementCard/ElementName";
import ElementDialogButton from "plos/src/components/ElementDialogButton";
import ElementShirt from "plos/src/components/ElementShirt";
import { PlayerNotesIcon } from "plos/src/components/playerNotes/PlayerNotesIcon";
import { ElementIcon } from "plos/src/components/tooltips/ElementIcon";
import { ElementIconButton } from "plos/src/components/tooltips/ElementIconButton";
import { usePlosTranslations } from "plos/src/contexts/PlosTranslationsContext";
import { ValidCopnr } from "plos/src/utils/validCopnr";
import { useSelector } from "react-redux";
import Captain from "../../img/icons/captain.svg?react";
import Sub from "../../img/icons/sub.svg?react";
import ViceCaptain from "../../img/icons/vice-captain.svg?react";
import ElementOverlayValue from "../PitchControls/ElementOverlayValue";
import PitchElementWrap from "./PitchElementWrap";
import {
  captainIconVariants,
  subIcon,
  subTooltipWrap,
  teamPitchElement,
  viceCaptainIconVariants,
} from "./teamPitchElement.css";
import { TeamPitchElementProps } from "./types";

const TeamPitchElement = ({
  actionMe,
  chipName,
  pick,
  renderDreamTeam,
  renderElementMenu,
  eventId,
}: TeamPitchElementProps) => {
  const { captain, viceCaptain, switchPlayer } = usePlosTranslations();
  const element = useSelector((state: RootState) =>
    getElement(state, pick.element),
  );
  const teamsById = useSelector(getTeamsById);

  if (!element) {
    return null;
  }
  const copnr = element.chance_of_playing_next_round as ValidCopnr;
  const team = teamsById[element.team];

  const captainVariant = chipName === "3xc" ? "tripleC" : "default";

  return (
    <PitchElementWrap variant={pick.subStatus || ""}>
      <ElementCardButton
        onPress={renderElementMenu}
        isDisabled={pick.subStatus === "invalid"}
      >
        <div className={teamPitchElement}>
          <ElementShirt
            alt={team.name}
            elementId={element.id}
            sizes="(min-width: 700px) 90px, 56px"
          />
          <div className={pitchElementData.default}>
            <ElementName
              copnr={element.news ? copnr : null}
              data-element-name="true"
            >
              {element.web_name}
            </ElementName>
            <ElementOverlayValue pick={pick} eventId={eventId} />
          </div>
        </div>
      </ElementCardButton>

      {pick.subStatus !== "invalid" && (
        <div>
          <div className={topLeftIconList}>
            {actionMe && typeof pick.subStatus !== "undefined" && (
              <div className={subTooltipWrap}>
                <ElementIconButton label={switchPlayer} onPress={actionMe}>
                  <Sub aria-hidden className={subIcon} />
                </ElementIconButton>
              </div>
            )}
            {pick.is_captain && (
              <ElementIcon label={captain}>
                <Captain
                  aria-hidden
                  className={captainIconVariants[captainVariant]}
                />
              </ElementIcon>
            )}
            {pick.is_vice_captain && (
              <ElementIcon label={viceCaptain}>
                <ViceCaptain
                  aria-hidden
                  className={viceCaptainIconVariants[captainVariant]}
                />
              </ElementIcon>
            )}
            {renderDreamTeam && renderDreamTeam(pick)}
          </div>

          {element.news && (
            <div className={topRightIcon}>
              <ElementDialogButton elementId={element.id} variant="pitch" />
            </div>
          )}

          <div className={element.news ? bottomRightIcon : topRightIcon}>
            <PlayerNotesIcon
              element={element}
              action={renderElementMenu}
              useDarkIconInDarkMode={true}
            />
          </div>
        </div>
      )}
    </PitchElementWrap>
  );
};

export default TeamPitchElement;
